@if (!metaData || !(metaData?.access === "DEACTIVATED")) {
  <div [ngStyle]="{ 'background-color': backgroundColor }" class="row col-md-12 cap-form-group-detail">
    <div [ngClass]="labelClass">
      <span class="bsg-label col-form-label"> {{ label | translate }} </span>
    </div>
    <div [ngClass]="bodyClass">
      <div [capHistinfo]="histInfo">
        @if (value || (value === 0 && showZeroValue)) {
          <span>{{ value }}</span>
        } @else {
          <ng-content></ng-content>
        }
      </div>
    </div>
  </div>
}
